// ===========================================
// HOOK: useEditarVencimientoForm
// ===========================================
// Hook TanStack Form para editar un vencimiento individual

import { useForm } from '@tanstack/react-form'
import { editarVencimientoSchema, type EditarVencimientoFormValues } from './editarVencimientoSchema'

interface UseEditarVencimientoFormOptions {
  onSubmit?: (value: EditarVencimientoFormValues) => Promise<void>
  defaultValues?: Partial<EditarVencimientoFormValues>
}

export function useEditarVencimientoForm(options: UseEditarVencimientoFormOptions = {}) {
  const form = useForm({
    defaultValues: {
      fecha_vencimiento: '',
      monto_determinado: null,
      observaciones: null,
      ...options.defaultValues,
    } as EditarVencimientoFormValues,
    validators: {
      onSubmit: editarVencimientoSchema,
    },
    onSubmit: async ({ value }) => {
      if (options.onSubmit) {
        await options.onSubmit(value)
      }
    },
  })

  return { form }
}

export type UseEditarVencimientoFormReturn = ReturnType<typeof useEditarVencimientoForm>
export type EditarVencimientoForm = UseEditarVencimientoFormReturn['form']
